/**
 * The room the phone's bottom nav takes above the bottom of the screen, as a CSS length; 0 where the
 * nav is a sidebar. Everything that sits above the nav is positioned from this.
 *
 * The safe area is left to the browser as env() rather than measured: iOS changes it when the toolbar
 * collapses, and nothing fires for that (the nav doesn't resize), so a measured number went stale and
 * every bar sat 34px too low (under the nav) or too high (a gap with the page showing through).
 * The nav's height and gap come from the nav, which is the part that can't change on its own.
 */
const NAV_GAP_PX = 10 // .sidebar's own `bottom: calc(10px + env(safe-area-inset-bottom))`

export function bottomNavOffsetCss(nav: HTMLElement | null): string {
  if (!nav || !window.matchMedia('(max-width: 768px)').matches) return '0px'
  if (window.getComputedStyle(nav).position !== 'fixed') return '0px'
  return `calc(${nav.offsetHeight + NAV_GAP_PX}px + env(safe-area-inset-bottom, 0px))`
}
